<p>
  scripts-init works!
</p>
